import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const StrategicRecommendations = ({ recommendations }) => {
  const [expandedCard, setExpandedCard] = useState(null);

  const toggleCard = (index) => {
    setExpandedCard(expandedCard === index ? null : index);
  };

  const getImpactColor = (impact) => {
    switch (impact) {
      case 'High': return 'text-success bg-success/10';
      case 'Medium': return 'text-warning bg-warning/10';
      case 'Low': return 'text-muted-foreground bg-muted/20';
      default: return 'text-muted-foreground bg-muted/20';
    }
  };

  const getCategoryIcon = (category) => {
    switch (category) {
      case 'Revenue Optimization': return 'TrendingUp';
      case 'Cost Management': return 'DollarSign';
      case 'Marketing Strategy': return 'Target';
      case 'Operational Efficiency': return 'Settings';
      case 'Guest Experience': return 'Star';
      default: return 'Lightbulb';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-sm">
      <div className="px-6 py-4 border-b border-border bg-muted/30">
        <h3 className="font-heading font-bold text-lg text-foreground">
          Strategic Recommendations
        </h3>
        <p className="font-body text-sm text-muted-foreground mt-1">
          Personalized strategies based on your RV park configuration
        </p>
      </div>
      <div className="p-6 space-y-4">
        {recommendations?.map((recommendation, index) => (
          <div key={index} className="border border-border rounded-lg overflow-hidden">
            <button
              onClick={() => toggleCard(index)}
              className="w-full px-4 py-4 bg-background hover:bg-muted/30 transition-colors duration-200 text-left"
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="flex items-center justify-center w-8 h-8 bg-primary/10 rounded-lg">
                    <Icon name={getCategoryIcon(recommendation?.category)} size={16} className="text-primary" />
                  </div>
                  <div>
                    <h4 className="font-heading font-semibold text-sm text-foreground">
                      {recommendation?.category}
                    </h4>
                    <p className="font-body text-xs text-muted-foreground">
                      {recommendation?.title}
                    </p>
                  </div>
                </div>
                <div className="flex items-center space-x-2">
                  <span className={`px-2 py-1 rounded-full font-body font-medium text-xs ${getImpactColor(recommendation?.impact)}`}>
                    {recommendation?.impact} Impact
                  </span>
                  <Icon 
                    name={expandedCard === index ? 'ChevronUp' : 'ChevronDown'} 
                    size={16} 
                    className="text-muted-foreground" 
                  />
                </div>
              </div>
            </button>

            {expandedCard === index && (
              <div className="px-4 pb-4 bg-muted/10 animate-slide-down">
                <div className="pt-4 space-y-4">
                  <p className="font-body text-sm text-foreground leading-relaxed">
                    {recommendation?.description}
                  </p>
                  
                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <h5 className="font-heading font-semibold text-xs text-muted-foreground uppercase tracking-wide mb-2">
                        Implementation Timeline
                      </h5>
                      <p className="font-body text-sm text-foreground">
                        {recommendation?.timeline}
                      </p>
                    </div>
                    <div>
                      <h5 className="font-heading font-semibold text-xs text-muted-foreground uppercase tracking-wide mb-2">
                        Expected ROI
                      </h5>
                      <p className="font-body text-sm text-success font-semibold">
                        {recommendation?.expectedROI}
                      </p>
                    </div>
                  </div>

                  {recommendation?.actionItems && (
                    <div>
                      <h5 className="font-heading font-semibold text-xs text-muted-foreground uppercase tracking-wide mb-2">
                        Action Items
                      </h5>
                      <ul className="space-y-1">
                        {recommendation?.actionItems?.map((item, itemIndex) => (
                          <li key={itemIndex} className="flex items-start space-x-2">
                            <Icon name="CheckCircle2" size={14} className="text-success mt-0.5 flex-shrink-0" />
                            <span className="font-body text-sm text-foreground">{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StrategicRecommendations;